import { Chip } from '@mui/material';
import { Tag } from '@wwf/sdk';
import { useRecordContext } from 'react-admin';

export const TagInputOption = () => {
    const record = useRecordContext<Tag>();
    if (!record) return null;

    return (
        <Chip
            component="span"
            size="small"
            variant="filled"
            label={record.name}
            sx={{
                '&.MuiChip-colorDefault': {
                    color: 'black',
                    backgroundColor: record.color || undefined,
                    border: 0,
                },
            }}
        />
    );
};

export const tagOptionText = <TagInputOption />;
export const tagInputText = (choice: Tag) => choice.name;
